import { loadComponents } from "./lib";
import type { TComponentModule } from "./types";

// import { initWba, sendEvent, WbaEvents } from "@js/shared/lib";

class App {
  constructor() {
    this.init = this.init.bind(this);
  }

  async init() {
    try {
      const componentLoaders: Array<() => Promise<TComponentModule>> = [];

      if (document.querySelector(".ngm-header")) {
        componentLoaders.push(() => import("@components/header"));
      }

      if (document.querySelector(".ngm-hero")) {
        console.log("hero");
        componentLoaders.push(() => import("@components/hero"));
      }

      if (document.querySelector(".ngm-articles")) {
        componentLoaders.push(() => import("@components/articles"));
      }

      if (document.querySelector(".ngm-article")) {
        componentLoaders.push(() => import("@components/article"));
      }

      await loadComponents(componentLoaders);
    } catch (error) {
      console.error("Unexpected error during app initialization", error);
    }

    if (window.location.hash !== "") {
      setTimeout(() => {
        const anchorElement = document.querySelector(window.location.hash);

        if (anchorElement !== null) {
          anchorElement.scrollIntoView({ block: "start", behavior: "instant" });
        }
      }, 0);
    }

    // initWba();
    // sendEvent(WbaEvents.PAGEVIEW);
  }
}

export { App };
